import ServicesInvoiceSimulator from "../../components/ServicesInvoiceSimulator/ServicesInvoiceSimulator";


function ServicesInvoiceSimulatorPage() {
  return <ServicesInvoiceSimulator />;
}

export default ServicesInvoiceSimulatorPage;
